import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AddNewProductService {

  constructor(private http: HttpClient) {}

  addProduct(customerData: any): Observable<any> {
    return this.http.post(`${environment.apiUrl}/api/new-productType`, customerData);
  }

}
